export default {"src":"/_next/static/media/start_filled.558eb930.svg","height":24,"width":24};